import * as React from "react";

import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { RemoveIcon } from "../RemoveRowButton/RemoveIcon/RemoveIcon";

export interface TabTitleProps {
    children: React.ReactNode;
    onClose?: () => void;
    bindingPath?: AbsoluteResolvedModelPath;
    disabled?: boolean;
    isReadOnly?: boolean;
}

export function TabTitle(props: TabTitleProps): JSX.Element {
    const hiddenRemoveIcon = props.onClose !== undefined && props.disabled;
    return (
        <>
            <>{props.children}</>
            {hiddenRemoveIcon && !props.isReadOnly && (
                <RemoveIcon size={14} onClick={props.onClose} verticalAlign="center" />
            )}
        </>
    );
}
